import React from 'react';
import { DropdownSelect } from '../../../../../components/Dropdown';
import { PdfComponentBorderProperties, PdfBorderStyle } from '../../../PdfComponent';
import { PdfComponentWithBorder } from '../PdfTemplateComponentBorder';

export default function PdfTemplateComponentBorderStyle({
  component,
  updateBorder,
}: {
  component: PdfComponentWithBorder;
  updateBorder: (border: Partial<PdfComponentBorderProperties>) => void;
}) {
  return (
    <DropdownSelect<PdfBorderStyle>
      items={Object.values(PdfBorderStyle)}
      textBuilder={s => s}
      value={component.border.style}
      label={'Border style'}
      onSelect={style => updateBorder({ style })}
    />
  );
}
